import type { FC } from 'react';

import { Loader } from '../loader/Loader';

import styles from './SlotsLoader.module.css';

export const SlotsLoader: FC = () => {
  return (
    <div className={styles.openingOverlay}>
      <Loader />
    </div>
  );
};
